import { isMockMode, postBlast, simulateDelay } from "../../api";

export const updateOrg = ({
	id,
	isEnabledShareOutsideOrg,
	isEnabledShareWithAnon,
}: {
	id: string;
	isEnabledShareOutsideOrg?: boolean;
	isEnabledShareWithAnon?: boolean;
}) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};

		return simulateDelay(50, () => testData);
	}

	return postBlast(`orgs/update`, {
		id,
		isEnabledShareOutsideOrg,
		isEnabledShareWithAnon,
	});
};
